import { EventCodes } from '../../../../App/model/event-codes';
import type { EventService } from '../../../../App/services/event-service';
import { ProcessItem } from '../../../Pandora/model/process-item';
import type { AttachmentMetaInfo } from './mx-attachment.contracts';
import type { MxBackgroundProcessesService } from '../../../Pandora/services/mx-background-processes-service';
import type { I18n } from '../../../../i18n/mx-internationalization';
import type { IWindowService } from 'angular';
import type { MxApplicationService } from '../../../../App/services/mx-application-service';

export class MxAttachmentProcessService {
	static $inject = ['mx.shell.EventService', 'mx.shell.BackgroundProcessesService', 'mx.internationalization', '$window', 'mx.shell.AppsService'];
	private preventHandler: (e: BeforeUnloadEvent) => void;
	constructor(
		private readonly eventService: EventService,
		private readonly backgroundProcessService: MxBackgroundProcessesService,
		private readonly i18n: I18n,
		private readonly $window: IWindowService,
		private readonly appService: MxApplicationService
	) {
		const currentApp = this.appService.getCurrentApplicationSync();
		const message = this.i18n.getFormatted('shell.mx-shell-background-processes.prevent_reload', currentApp.name);
		this.preventHandler = (event: BeforeUnloadEvent) => {
			event.preventDefault();
			event.returnValue = message;
			return message;
		};
	}

	public createForegroundProcess(attachmentInfo: AttachmentMetaInfo): ProcessItem {
		const initiatedBy = attachmentInfo.uploadedBy;
		const operationName = this.i18n.get('shell.mx-shell-background-processes.uploading');
		const statusDetails = attachmentInfo.objectTitle ? `${attachmentInfo.objectTitle}: ${attachmentInfo.name}` : attachmentInfo.name;
		const cancelable = true;
		const processItem = new ProcessItem({
			Id: attachmentInfo.id,
			OperationName: operationName,
			InitiatedBy: initiatedBy,
			StatusDetails: statusDetails,
			Cancelable: cancelable,
		});
		processItem.longRunning = (attachmentInfo.size || 0) > 5 * 1024 * 1024;
		this.backgroundProcessService.addForegroundProcess(processItem);
		this.eventService.dispatchEvent(EventCodes.ForegroundProcessCreated, processItem);
		this.preventReload(processItem);
		return processItem;
	}

	public getForegroundProcessById(id: string): ProcessItem | undefined {
		return this.backgroundProcessService.foregroundProcesses.find((process) => process.id === id);
	}

	private preventReload(processItem: ProcessItem) {
		if (!processItem.longRunning) {
			return;
		}
		if (this.backgroundProcessService.foregroundProcesses.filter((process) => !process.finishTime).length === 1) {
			this.$window.addEventListener('beforeunload', this.preventHandler);
		}
		processItem.onProcessStatusUpdated(async () => {
			if (this.backgroundProcessService.foregroundProcesses.every((process) => process.finishTime)) {
				this.$window.removeEventListener('beforeunload', this.preventHandler);
			}
		});
	}
}
